var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkill6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 47.9998 33.8385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.2395 9.4642C38.2395 10.3672 38.124 11.3647 37.8743 12.4019C37.3516 12.3475 36.8263 12.3217 36.3008 12.3247C32.346 12.3247 28.641 13.6687 25.5885 16.2217C21.135 19.9462 19.4655 25.4744 21.5385 29.6977C21.7688 30.1777 22.0372 30.6195 22.326 31.0417C21.7687 31.3492 21.174 31.6364 20.5785 31.9049C20.1205 32.1137 19.6231 32.2217 19.1198 32.2217C18.6164 32.2217 18.119 32.1137 17.661 31.9049C5.9895 26.6069 0 15.915 0 9.46495C0 7.0267 0.96 4.62745 2.80275 2.7457C7.17975 -1.74605 15.7605 -0.690051 19.1198 5.64445C22.479 -0.690051 31.0598 -1.74605 35.4368 2.7457C37.2795 4.62745 38.2395 7.0267 38.2395 9.46495V9.4642ZM26.817 17.7C23.055 20.8485 21.615 25.4745 23.2657 28.8337C23.3235 28.9492 23.4007 29.0835 23.4772 29.199C26.2222 25.11 29.4278 22.0964 32.9985 20.2334C33.4598 19.9844 34.0545 20.1765 34.3035 20.637C34.5345 21.0975 34.3613 21.693 33.9008 21.9232C30.522 23.7082 27.4703 26.6257 24.8213 30.6194L24.6675 30.8497C28.4872 34.9957 36.627 36.1094 41.79 25.6664C44.574 20.0414 48.2025 20.7712 47.991 19.9072C47.166 16.491 35.6085 10.3672 26.817 17.7Z",
    fill: "var(--fill-0, #B707AB)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill6);
export default __webpack_public_path__ + "static/media/skill-6.99d8d2dc89b39083493ad858b7adc3b8.svg";
export { ForwardRef as ReactComponent };